import { Box, Typography, Stack, Button } from "@mui/material";
import { useRouter } from "next/router";
import { useState } from "react";
import TextButton from "@/components/common/buttons/textButton";
import MembershipCardDescription from "@/components/online-store/memberships/membershipCardDescription";
import MembershipCardMoreDetailsModal from "@/components/online-store/memberships/membershipCardMoreDetailsModal";
import { GREY, WHITE } from "@/config/mui/colorPalette";
import {
  MedspaMembership,
  OnlineStoreTab,
} from "@/views/online-store/onlineStoreView";

export default function OnlineStoreMembershipCard({
  membership,
}: {
  membership: MedspaMembership;
}) {
  const {
    query: { medspaSlug },
  } = useRouter();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { id, title } = membership;

  const url = `/online-store/${medspaSlug}/${OnlineStoreTab.MEMBERSHIPS}/${id}/sign-up`;

  return (
    <>
      <Box
        sx={{
          border: `1px solid ${GREY[20]}`,
          borderRadius: "16px",
          p: 1.5,
          bgcolor: WHITE,
        }}
      >
        <Typography variant="subtitleDefault">{title}</Typography>

        <MembershipCardDescription membership={membership} />
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}
        >
          <Button variant="contained" size="small" href={url}>
            Sign up now
          </Button>
          <TextButton onClick={() => setIsModalOpen(true)}>
            More details
          </TextButton>
        </Stack>
      </Box>
      <MembershipCardMoreDetailsModal
        membership={membership}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        url={url}
      />
    </>
  );
}
